<template>
  <!--main-->
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="login__page">
          <div> <!--키패드 이슈 수정 div-->
            <div class="login__page__logo"></div>
            <div class="form" style="padding:0 1.6rem;">
              <ul class="form__ul">
                <li class="form__li">
                  <div class="form__in">
                    <div class="inline">
                      <label class="input" style="margin-bottom: 1.6rem;">
                        <input type="text" placeholder="아이디" v-model.trim="params.userID" maxlength="15">
                      </label>
                    </div>
                  </div>
                </li>
                <li class="form__li">
                  <div class="form__in">
                    <div class="inline">
                      <label class="input">
                        <input type="password" placeholder="비밀번호" v-model="params.userPWD" @keyup.13="doLogin" maxlength="15">
                      </label>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="checkbox_line">
<!--                <label class="checkbox">-->
<!--                  <input type="checkbox" name="auto_login" v-model="isAutoLogin">-->
<!--                  <span class="label"><span>자동로그인</span></span>-->
<!--                </label>-->
                <button class="checkbox_line__txt underline" @click="$router.push('/account/joinStep')">회원가입</button>
                <button class="checkbox_line__txt underline" @click="$router.push('/account/findID')">아이디/비밀번호 찾기</button>
              </div>
              <div class="btn m36">
                <button class="left" @click="doLogin">로그인</button>
              </div>
              <div class="checkbox_line__txt underline" style="text-align: right; padding: 1rem 0;">
                <a href="#" @click.prevent="moveAdminPage">관리자 로그인</a>
              </div>
            </div>
          </div>
          <div class="sign__login">
            <button class="sign__txt_btn underline" @click="$router.push('/account/inquire')">비회원 도입문의</button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {required} from 'vuelidate/lib/validators'

export default {
  data: function () {
    return {
      isAutoLogin: false,
      params: {
        appVersion: '',
        deviceID: '',
        deviceTypeID: '',
        registrationKey: '',
        loginType: this.$ConstCode.LOGIN_TYPE.USER.value,
        userID: '',
        userPWD: '',
        joinPath: 11,
        isAutoLogin: 1
      },
      valid: {
        msg: {
          userID: '',
          userPWD: ''
        }
      },
    }
  },
  validations: {
    params: {
      userID: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.userID = '아이디를 입력해주세요.'
            return false
          }
          return true
        }
      },
      userPWD: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.userPWD = '비밀번호를 입력해주세요.'
            return false
          }
          // if(!this.$Util.isPasswordValid(val)) {
          //   this.valid.msg.userPWD = '영문자, 숫자 혼합 8~15자 이내로 입력해주세요.'
          //   return false
          // }
          return true
        }
      }
    }
  },
  // watch: {
  //   isAutoLogin: function (val) {
  //     this.params.isAutoLogin = val ? 1 : -1
  //   }
  // },
  created: function () {
    const deviceInfo = localStorage.deviceInfo === undefined ? {} : JSON.parse(localStorage.deviceInfo)
    if (!this.$Util.isEmpty(deviceInfo)) {
      this.params.appVersion = deviceInfo.appVersion
      this.params.deviceID = deviceInfo.deviceID
      this.params.deviceTypeID = deviceInfo.deviceTypeID
      this.params.registrationKey = deviceInfo.pushToken
    }
  },
  methods: {
    moveAdminPage: function () {
      this.$Util.nativeLink('https://admin.kiupnuri.com')
    },
    callBackTestLocal2: function () {
    },
    doLogin: function () {
      this.$v.$touch()
      if(this.$v.params.userID.$error) {
        this.$Util.modalAlert({message: this.valid.msg.userID})
        return false
      }
      if(this.$v.params.userPWD.$error) {
        this.$Util.modalAlert({message: this.valid.msg.userPWD})
        return false
      }

      if (this.$Util.isApp()) {
        const deviceInfo = JSON.parse(localStorage.deviceInfo) || {}
        if (!this.$Util.isEmpty(deviceInfo)) {
          this.params.deviceType = deviceInfo.deviceType
          this.params.deviceID = deviceInfo.deviceID
          this.params.deviceTypeID = deviceInfo.deviceTypeID
          this.params.registrationKey = deviceInfo.pushToken
        }

        this.params.joinPath = 11 // 앱 로그인임을 백엔드에 전송
      }

      this.$AccountSvc.login(this.params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          if (code === 1) {
            // if (entity.userStatus === 100) {
              if(entity.userType === 1) {
                this.$router.replace({path: '/main/home'})
              } else if (entity.userType === 2) {
                this.$router.push({path: '/elect/select'})
              }
            // } else {
            //   this.$router.replace({path: '/account/wait'})
            // }
          } else {
            this.$Util.modalAlert({message: message})
          }
        })
    }
  }
}
</script>

<style scoped></style>
